import OtpInput from './OtpInput.vue'

export { OtpInput }
export default OtpInput
